import React from 'react'
import NavBar from '../pages/NavBar'

const Login = () => {
    return (
        <>
            <NavBar />
            <div className='flex justify-center mt-32'>Login</div>
        </>
    )
 
}
export default Login

